import { type EditorView } from 'prosemirror-view'
import Styles from './TemplatePreview.module.scss'
import { ProsePreview } from 'common/ProsePreview/ProsePreview'
import { ArticleFlat } from 'types'
import { Node, Schema } from 'prosemirror-model'
import { schema as nerudaSchema } from 'prose-core'

import { Skeleton } from 'antd'
import { useArticle } from 'hooks/queries/articles/useArticle'

interface TemplatePreviewProps {
  articleId: string
  onPreviewInit?: (view: EditorView) => void
}

const prepareNodes = (elements: any[], schema: Schema) => {
  return elements.map((node) => {
    return Node.fromJSON(schema, node.data_json)
  })
}

export const TemplatePreview = ({ articleId, onPreviewInit }: TemplatePreviewProps) => {
  const articleQuery = useArticle(articleId)
  const article = articleQuery.data?.article as ArticleFlat

  return (
    <div className={Styles.previewContainer}>
      <div className={Styles.preview}>
        {articleId === '' && <></>}
        {articleQuery.isLoading && <Skeleton />}
        {articleQuery.isError && (
          <div className={Styles.errorState}>Preview not available. Try refreshing the page.</div>
        )}
        {articleQuery.isSuccess && (
          <ProsePreview
            articleStyles={[article.workspace_article_style, article.article_style]}
            schema={nerudaSchema}
            nodes={prepareNodes(article.elements, nerudaSchema)}
            onInit={onPreviewInit}
          />
        )}
      </div>
    </div>
  )
}
